import { ApiUtil as api } from '@/utils/api.util.js'

export class ContractService {

	static URL = process.env.API_URL + process.env.API_VER

	static RESOURCE = '/contracts/'

	static all(queryParams = {}) {

		return api.get(this.URL + this.RESOURCE, queryParams)

	}

	static list(queryParams = {}) {

		return api.get(this.URL + this.RESOURCE, queryParams)

	}

	static create(queryParams = {}) {

		return api.post(this.URL + this.RESOURCE, queryParams)

	}

	static show(id, queryParams = {}) {

		return api.get(this.URL + this.RESOURCE + id, queryParams)

	}

	static update(id, queryParams = {}) {

		return api.put(this.URL + this.RESOURCE + id, queryParams)

	}

	static archive(id) {

		return api.put(this.URL + this.RESOURCE + 'archive/' + id)

	}

	static delete(id) {

		return api.delete(this.URL + this.RESOURCE + id)

	}

	static restore(id) {

		return api.put(this.URL + this.RESOURCE + 'restore/' + id)

	}

	static getCodeSets() {
		return Promise.resolve();
	}

	static getStartCodeTypeFromAttributes(attributes) {
		let attribute = null;
		if (Array.isArray(attributes)) {
			attribute = attributes.find(a => {
				return (a.code && a.code.toUpperCase() === '[SYSTEM][ORDER][CODE_CHAIN][START]');
			});
		}
		return attribute ? attribute.value : null;
	}

	static archiveCodes(id, data = {}) {
		return api.put(this.URL + this.RESOURCE + id + '/archive-codes', data);
	}

	static restoreCodes(id, data = {}) {
		return api.put(this.URL + this.RESOURCE + id + '/restore-codes', data);
	}

	static listTypes(queryParams = {}) {
		return api.get(this.URL + this.RESOURCE + 'types', queryParams);
	}

	static archiveRates(id, data = {}) {
		return api.put(this.URL + this.RESOURCE + id + '/archive-rates', data);
	}

	static restoreRates(id, data = {}) {
		return api.put(this.URL + this.RESOURCE + id + '/restore-rates', data);
	}

	static copyAssetsStatus(id, data = {}) {
		return api.get(this.URL + this.RESOURCE + id + '/copy-assets-status', data);
	}

	static copyAssets(id, data = {}) {
		return api.post(this.URL + this.RESOURCE + id + '/copy-assets', data);
	}

	static copyCodeRelations(id, data = {}) {
		return api.post(this.URL + this.RESOURCE + id + '/copy-code-relations', data);
	}	
}



// WEBPACK FOOTER //
// ./src/services/contract.service.js